import request from '@/utlis/request'
// 查询委托列表
export function GetEntrustList(data) {
    return request({
        url: '/admin/car/findCarByCondition',
        method: 'post',
        data: {
            ...data,
            type: data.type ? data.type : 1
        }
    })
}
// 新增委托
export function AddEntrust(data) {
    return request({
        url: '/admin/entrust/createEntrust',
        method: 'post',
        data
    })
}
//修改委托
export function ModifyEntrust(data) {
    return request({
        url: '/admin/entrust/updateEntrustById',
        method: 'post',
        data
    })
}
//删除委托
export function DelEntrust(params) {
    return request({
        url: '/admin/entrust/deleteEntrust',
        method: 'POST',
        params
    })
}
// 进入审核阶段
export function ExamineEntrust(params) {
    return request({
        url: '/admin/entrust/joinMaintain',
        method: 'get',
        params
    })
}
// 根据ID查询详情
export function DetailsEntrust(params) {
    return request({
        url: '/admin/entrust/findEntrustById',
        method: 'get',
        params
    })
}

// 查询全部保全机构
export function GetinstitutionList(params) {
    return request({
        url: '/admin/institution/findAllInstitution',
        method: 'post',
        data: {
            type: 1,
            currentPage: 1,
            pageSize: 999,
            ...params
        }
    })
}
// 查询 某个保全机构下的 保全人员
export function GetinstitutionPeople(id) {
    return request({
        url: '/admin/institution/finduserByInstitutionId',
        method: 'get',
        params: {
            institutionId: id
        }
    })
}

/**
 * 查询当前登录后台用户拥有的角色 + 权限 列表
 * @returns 
 */
export function GetAuthorityList() {
    return request({
        url: '/admin/sysuser/findSysuserRolesAndRules',
        method: 'get',
    })
}

/**
 * 省市区查询
 */
export function QueryCurrentLocation(data, params = {
    type: ""
}) {
    return request({
        url: '/admin/area/queryCurrentLocation',
        method: 'POST',
        data,
        params,
    })
}
